import { render, staticRenderFns } from "./sso-mapping-card.vue?vue&type=template&id=2c90c4b6"
import script from "./sso-mapping-card.vue?vue&type=script&lang=js"
export * from "./sso-mapping-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports